import React from 'react';

import classes from './ButtonsSeparator.module.scss';

export const ButtonsSeparator = () => {
    return <div className={classes.buttonsSeparator}></div>;
};
